// extracted by mini-css-extract-plugin
export default {"primaryButton":"Buttons_primaryButton__C3asJ","secondaryButton":"Buttons_secondaryButton__gZQWF"};